import { createRequestActionTypes } from '../../../shared/utility';

export const PSPAcquirerActions = {
    fetchPSPAcquirerDetails: createRequestActionTypes('FETCH_PSP_ACQUIRER_DETAILS'),
    createAndUpdatePSPAcquirerMapping: createRequestActionTypes('CREATE_AND_UPDATE_PSP_ACQUIRER_MAPPING'),
    fetchPSPMasterData: createRequestActionTypes('FETCH_PSP_MASTER_DATA'),
    fetchAcqMasterData: createRequestActionTypes('FETCH_ACQ_MASTER_DATA'),
    fetchPspIntegrationModeMasterData: createRequestActionTypes('FETCH_PSP_INTEGRATION_MODE_MASTER_DATA'),
}